const VAPID_PUBLIC_KEY_STORAGE_KEY = "web_push_vapid_public_key";

export const clearWebPushSubscriptionState = () => {
    localStorage.removeItem(VAPID_PUBLIC_KEY_STORAGE_KEY);
};

export const getExistingServiceWorkerRegistration = async () => {
    try {
        return await navigator.serviceWorker.getRegistration();
    } catch (error) {
        console.warn("Failed to get service worker registration:", error);
        return undefined;
    }
};

export const unsubscribeLocalWebPushSubscription = async () => {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
        clearWebPushSubscriptionState();
        return null;
    }

    const registration = await getExistingServiceWorkerRegistration();

    if (!registration) {
        clearWebPushSubscriptionState();
        return null;
    }

    const subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
        clearWebPushSubscriptionState();
        return null;
    }

    try {
        await subscription.unsubscribe();
    } finally {
        clearWebPushSubscriptionState();
    }

    return subscription;
};
